import React, {useEffect, useState} from 'react';

import {getTeams} from '../DropdownDataProviders' ;
import { renderDropdown, renderDropdownReadOnly} from "../DropdownFunctions";
import SpinnerDiv from "../SpinnerDiv";
import PropTypes from "prop-types";

const DropdownTeams = (props ) =>
{
    const [ data, setData ] = useState ( { loading: true, items : [] } ) ;

    useEffect(() => {
        getTeams(false).then (response =>
        {
            setData ( { loading: false, items: response }) ;
        })
    }, []);

    return data.loading === true ? <SpinnerDiv/> :
    (
        props.readOnly === 'readonly' ? renderDropdownReadOnly(props, data) : renderDropdown(props, data)
    )
}

export default DropdownTeams;

DropdownTeams.defaultProps =
{
    defaultClassName: 'form-group'
}

DropdownTeams.propTypes = {
    onChange: PropTypes.func.isRequired
};